import { render, staticRenderFns } from "./Profession.vue?vue&type=template&id=bbb4deaa&"
import script from "./Profession.vue?vue&type=script&lang=js&"
export * from "./Profession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports